import {
  Box,
  Grid,
  Paper,
  Button,
  TextField,
  MenuItem,
  CircularProgress
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { getIssuers } from 'src/store/actions/LogActions';
import { filterTopupInvoice } from 'src/store/actions/TopupActions';
import moment from 'moment';
import { getLastNDays } from 'src/utils/utils';

function TopupFilter() {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const issuersData = useSelector((state) => state.Logs.issuersData);
  const [formValues, setFormValues] = React.useState({
    values: { fromDate: getLastNDays(30), toDate: getLastNDays(0) }
  });

  useEffect(() => {
    dispatch(getIssuers());
  }, []);

  const handleChange = (event) => {
    event.persist();
    setFormValues((formValues) => ({
      ...formValues,
      values: {
        ...formValues.values,
        [event.target.name]: event.target.value
      }
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    const obj = {
      issuerID: formValues.values.issuerID || '-',
      fromDate: moment(formValues.values.fromDate).unix() || '-',
      toDate: moment(formValues.values.toDate).unix() || '-'
    };
    const response = await dispatch(filterTopupInvoice(obj));
    if (response) {
      setLoading(false);
    }
  };
  return (
    <Paper>
      <Grid
        container
        spacing={2}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          paddingLeft: 10,
          paddingRight: 10
        }}
      >
        {profile?.super == 1 && (
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              select
              margin="normal"
              name="issuerID"
              label="Client"
              required
              variant="outlined"
              size="small"
              onChange={handleChange}
              value={formValues.values.issuerID || ''}
            >
              <MenuItem value="">Please select client</MenuItem>
              {issuersData.map((item, index) => (
                <MenuItem key={index} value={item.issuerID}>
                  {item.fullname}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        )}

        <Grid item xs={12} md={3}>
          <TextField
            id="date"
            label="From Date"
            type="date"
            fullWidth
            name="fromDate"
            onChange={handleChange}
            value={formValues.values.fromDate || ''}
            InputLabelProps={{
              shrink: true
            }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            id="todate"
            label="To Date"
            type="date"
            name="toDate"
            fullWidth
            onChange={handleChange}
            value={formValues.values.toDate || ''}
            InputLabelProps={{
              shrink: true
            }}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Button
            disabled={loading}
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            {loading && <CircularProgress size="1.5rem" />} &nbsp; Filter
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default TopupFilter;
